import { NavigationGuard } from 'vue-router';

/**
 * Guard that sets meta tags for routes that need specific SEO meta tags
 */
const setMetaTagsGuard: NavigationGuard = (to, _from, next) => {
  // Handle robots meta tag
  if (typeof to.meta?.robots === 'string' && to.meta.robots) {
    let existingMetaTag = document.querySelector('meta[name="robots"]');
    if (!existingMetaTag) {
      existingMetaTag = document.createElement('meta');
      existingMetaTag.setAttribute('name', 'robots');
      document.head.appendChild(existingMetaTag);
    }

    existingMetaTag.setAttribute('content', to.meta.robots);
  }

  // Always proceed to the next guard
  next();
};

export default setMetaTagsGuard;
